import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from 'src/app/data.service';

interface StornoResult {
  id: string;
  stornoId?: string;
  sorszam?: number;
  szamlaszam?: string;
  stornoSzamlaszam?: string;
  ok: boolean;
  navbekuldve?: boolean;
  error?: string;
  navError?: any;
}

@Component({
  selector: 'app-storno-tomeges',
  templateUrl: './storno-tomeges.component.html',
  styleUrls: ['./storno-tomeges.component.scss'],
})
export class StornoTomegesComponent implements OnInit {
  sajatIntezmeny: any;
  tombok: any[] = [];
  selectedTomb: string = '';
  from: number = null;
  to: number = null;
  reverseEgyenleg = true;
  loading = false;
  osszesito: { osszesen: number; sikeres: number; navSikeres: number } = null;
  results: StornoResult[] = [];

  constructor(private http: HttpClient, private data: DataService) { }

  async ngOnInit() {
    this.sajatIntezmeny = await this.data.getFromStorage('sajatIntezmeny');
    this.loadTombok();
  }

  private intezmenyPath(): string {
    return String(this.sajatIntezmeny?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
  }

  loadTombok() {
    if (!this.sajatIntezmeny?.intezmenyId) return;
    this.http.get<any[]>('/api/szamla/tombok/' + this.intezmenyPath()).subscribe({
      next: (rows) => {
        this.tombok = rows || [];
        if (this.tombok.length === 1) this.selectedTomb = this.tombok[0].id;
      },
      error: (error) => {
        console.error('Számlatömbök betöltési hiba:', error);
        this.data.sendToast('Nem sikerült betölteni a számlatömböket.', 'error');
      },
    });
  }

  get ervenyes(): boolean {
    return (
      !!this.selectedTomb &&
      this.from !== null &&
      this.to !== null &&
      Number.isFinite(+this.from) &&
      Number.isFinite(+this.to) &&
      +this.from > 0 &&
      +this.to > 0
    );
  }

  async stornozas(e?: any) {
    if (e && e.detail && e.detail.role != 'confirm') return;
    if (!this.ervenyes) {
      this.data.sendToast('Adja meg a számlatömböt és az intervallumot!', 'error');
      return;
    }

    this.loading = true;
    this.results = [];
    this.osszesito = null;
    await this.data.showLoading('Tömeges stornózás folyamatban...');

    this.http
      .post('/api/nav/storno-koteg/' + this.intezmenyPath(), {
        tomb: this.selectedTomb,
        from: +this.from,
        to: +this.to,
        egyenleg: this.reverseEgyenleg,
      })
      .subscribe({
        next: (response: any) => {
          this.data.hideLoading();
          this.loading = false;
          if (response.status == 'OK') {
            this.results = response.results || [];
            this.osszesito = {
              osszesen: response.osszesen || 0,
              sikeres: response.sikeres || 0,
              navSikeres: response.navSikeres || 0,
            };
            if (this.osszesito.osszesen === 0) {
              this.data.sendToast('Nem található stornózható számla a megadott intervallumban.', 'warning');
            } else {
              this.data.sendToast(
                `${this.osszesito.sikeres}/${this.osszesito.osszesen} bizonylat stornózva, ${this.osszesito.navSikeres} sikeresen beküldve a NAV felé.`,
                'success'
              );
            }
          } else {
            this.data.sendToast(response.error || 'A tömeges stornózás sikertelen.', 'error');
          }
        },
        error: (error) => {
          this.data.hideLoading();
          this.loading = false;
          console.error('Tömeges storno hiba:', error);
          this.data.sendToast('A tömeges stornózás sikertelen.', 'error');
        },
      });
  }

  navHibaSzoveg(r: StornoResult): string {
    if (!r.navError) return '';
    if (typeof r.navError === 'string') return r.navError;
    try {
      return JSON.stringify(r.navError);
    } catch {
      return 'NAV hiba';
    }
  }
}
